<template>
    <div class="gallery-diary-area">
        <div class="report-section">

            <div class="sub-area">
                <div class="section-title">{{ $t('menu.agridiary') }}</div>
            </div>

            <div class="motto">
                <!-- <i class="fa fa-quote-left"></i> -->
                屬於我們的點點滴滴
                <!-- <i class="fa fa-quote-right"></i> -->
                <div class="description">
                    <p>
                        這是我們從認識、交往到決定共度一生的紀錄，每張照片都代表一段回憶，每段回憶都讓我們更加確信彼此有多重要。
                    </p>

                </div>
            </div>

            <!-- <CollapseArea :areaTitle="$t('menu.agridiary') + ' Slideshow Gallery'"> -->
                <PrintArea :areaScroll="false" :areaWidth="'full'">
                    <template v-slot:default>

                        <div class="image-gallery">

                            <!-- Full-width images with number text -->
                            <div class="mySlides">
                                <b-row>
                                    <b-col lg=5>
                                        <!-- <div class="numbertext">{{ currentSlide + 1 }} / {{ arranged_data.length }}</div> -->
                                        <div class="current-slide"
                                            :style="$tools.style.imgCover( $config.checkURL('photo', arranged_data[ currentSlide ].pic), 'contain' )"
                                            :alt="arranged_data[ currentSlide ].action"
                                        ></div>

                                    </b-col>
                                    <b-col lg=6 align-self="center">
                                        <div class="caption-container">
                                            <!-- <div>
                                                <div class="log-icon" v-html="get_LogIcon( 'farming_activity' )"></div>
                                                <div class="log-type">{{ $t('menu.farming_activity') }}</div>
                                            </div> -->
                                            <!-- <h3 class="log-title">{{ arranged_data[ currentSlide ].action }}</h3> -->
                                            <p class="log-body">{{ arranged_data[ currentSlide ].description }}</p>
                                            <p class="log-time">
                                                － {{ $tools.date.dateFormat( arranged_data[ currentSlide ].log_time, 'YYYY-MM-DD HH:mm' ) }}
                                                {{ get_Recorder( arranged_data[ currentSlide ] ) }}
                                                <span class="log-user" v-if="arranged_data[ currentSlide ].user">
                                                    {{ arranged_data[ currentSlide ].user.fullname }}
                                                </span> －
                                            </p>
                                            <div class="text-right text-muted">{{ currentSlide + 1 }} / {{ arranged_data.length }}</div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>

                            <!-- Next and previous buttons -->
                            <a class="prev" @click="plus_Slides(-1)">&#10094;</a>
                            <a class="next" @click="plus_Slides(1)">&#10095;</a>

                            <!-- Thumbnail images -->
                            <div :class="'image-thumbnails' + ( bShowAllThumbnails ? '' : '-scroll' )">
                                <div class="image-row">
                                    <div class="image-column" v-for="(item, idx_item) in arranged_data" :key="idx_item">
                                        <div :class="class_PreviewSlide(idx_item)"
                                            :style="$tools.style.imgCover( $config.checkURL('photo', item.pic), 'cover' )"
                                            @click="currentSlide = idx_item"
                                            :alt="item.action"
                                        ></div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center" v-if="arranged_data.length > 12">

                                <b-button v-if="bShowAllThumbnails"
                                    variant="success" class="mt-3"
                                    @click="bShowAllThumbnails = false"
                                ><i class="fa fa-minus"></i> Show Less Thumbnails
                                </b-button>

                                <b-button v-else
                                    variant="success" class="mt-3"
                                    @click="bShowAllThumbnails = true"
                                ><i class="fa fa-plus"></i> Show All Thumbnails</b-button>

                            </div>
                        </div>

                    </template>
                </PrintArea>
            <!-- </CollapseArea> -->

            <br>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CollapseArea from '@/views/project/report/components/layout/CollapseArea';
import PrintArea    from '@/views/project/report/components/layout/PrintArea';
import PrintHide    from '@/views/project/report/components/layout/PrintHide';

export default {
    props: {
        data: {
            type: Array,
            default: function () { return [] },
        },
    },
    components: {
        CollapseArea,
        PrintArea,
        PrintHide,
    },
    data () {
        return {
            currentSlide: 0,  // index
            bShowAllThumbnails: false,
        }
    },
    mounted ()
    {
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
        }),

        arranged_data ()
        {
            return this.data
        },

    },
    watch: {

    },
    methods: {

        get_LogIcon (type)
        {
            switch (type)
            {
                case 'farming_activity':        return `<i class="fa fa-tasks"></i>`;
                case 'crop_traits':             return `<i class="fa fa-leaf"></i>`;
                case 'disease_pest_control':    return `<i class="fa fa-bug"></i>`;
                default: return `<i class="fa fa-tasks"></i>`;
            }
        },

        get_Recorder (diaryData)
        {
            let _first_name = ( diaryData.recorder_first_name ? diaryData.recorder_first_name : '' )
            let _last_name  = ( diaryData.recorder_last_name ? diaryData.recorder_last_name : '' )
            switch (this.language)
            {
                case 'en':
                    return `${ _first_name } ${ _last_name }`
                default:
                    return `${ _last_name } ${ _first_name }`
            }
        },

        plus_Slides (n)
        {
            if ( this.currentSlide + n >= this.arranged_data.length )
            {
                this.currentSlide = 0
            }
            else if ( this.currentSlide + n < 0 )
            {
                this.currentSlide = this.arranged_data.length - 1
            }
            else
            {
                this.currentSlide = this.currentSlide + n
            }
        },

        class_PreviewSlide (index)
        {
            let _class = 'demo cursor'
            if ( this.currentSlide == index ) _class += ' active'
            return _class
        },

    },
}
</script>

<style lang="scss" scoped>

.gallery-diary-area
{
    color: #716664;
    // background-color: rgb(32, 49, 56);
    background-color: #f8dcd9;//rgba(118, 58, 78, 1);
}


.section-sub-title
{
    color: #716664;
}

.sub-area
{
    padding: 20px 20px;
    .section-title {
        color: #716664;
    }
}

.reports-style-period-1 .description
{
    color: #716664;
}



$gallery-bg-color: rgb(34, 34, 34);

/* Position the image container (needed to position the left and right arrows) */
.image-gallery {
    position: relative;
}

/* Hide the images by default */
.mySlides {
    background-color: $gallery-bg-color;
}
.current-slide
{
    height: 50vh;

    @media only screen and (max-width: 1500px)
    {
        height: 40vh;
    }
    @media only screen and (max-width: 1200px)
    {
        height: 25vh;
    }
    @media only screen and (max-width: 800px)
    {
        height: 36vh;
    }
    @media only screen and (max-width: 700px)
    {
        height: 35vh;
    }
    @media only screen and (max-width: 600px)
    {
        height: 28vh;
    }
    @media only screen and (max-width: 500px)
    {
        height: 30vh;
    }
    @media only screen and (max-width: 400px)
    {
        height: 28vh;
    }
}

/* Add a pointer when hovering over the thumbnail images */
.cursor {
    cursor: pointer;
}

/* Next & previous buttons */
.prev,
.next {
    cursor: pointer;
    position: absolute;
    top: 25%; //50%;
    width: auto;
    padding: 16px;
    margin-top: -50px;
    color: lightgrey !important;
    background-color: rgba(0, 0, 0, 0.5);
    font-weight: bold;
    font-size: 20px;
    border-radius: 0 3px 3px 0;
    user-select: none;
    -webkit-user-select: none;
}

/* Position the "next button" to the right */
.next {
    right: 0;
    border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
    color: rgb(95, 176, 127) !important;
    background-color: rgba(0, 0, 0, 0.8);
}

/* Number text (1/3 etc) */
.numbertext {
    color: #f2f2f2;
    background-color: rgba( $gallery-bg-color, 0.5 );
    font-size: 12px;
    padding: 5px 15px;
    position: absolute;
    top: 0;
}

/* Container for image text */
.caption-container {
    text-align: center;
    background-color: #222;
    padding: 5px 16px 0px 16px;
    color: white;
}
.log-icon
{
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    font-size: 1.4rem;
    width: 34px;
    height: 34px;
    margin: 10px 5px;
    border-radius: 20px;
    border: 3px solid #90ba2e;
    padding-left: 4px;
}
.log-type
{
    display: inline-block;
    vertical-align: middle;
    font-size: 1.4rem;
    color: #90ba2e;
    margin: 10px 5px;
}
.log-title
{
    font-size: 1.5rem;
    margin-top: 5px;
}
.log-body
{
    display: inline-block;
    text-align: left;
    font-size: 1.2rem;
}
.log-time
{
    font-size: 1.2rem;
    text-align: right;

    @media only screen and (max-width: 990px)
    {
        text-align: center;
    }
}
.log-user
{
    margin-left: 5px;
}

.image-row:after {
    content: "";
    display: table;
    clear: both;
}


/* Thumbnails */
.area-overflow-y
{
    overflow-x: hidden;
    overflow-y: auto;//scroll;
    white-space: nowrap;
}
.scroll-style-gray
{
    cursor: pointer !important;
    // CSS Scrollbars Module Level 1
    scrollbar-width: thin;
    scrollbar-color: rgba(45, 79, 47, 0.9) rgba(#90ba2e, 0.9);
}
.image-thumbnails-scroll
{
    @extend .area-overflow-y;
    @extend .scroll-style-gray;
    margin-bottom: 5px;
    padding-bottom: 5px;
    max-height: 40vh;

    @media only screen and (max-width: 500px)
    {
        max-height: 30vh;
    }
}

/* Six columns side by side */
.image-column {
    float: left;
    width: 16.66%;
}

/* Add a transparency effect for thumnbail images */
.demo {
    opacity: 0.6;


    width: 100%;
    height: 120px;
}

.active,
.demo:hover {
    opacity: 1;
}

</style>
